/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeActivityEventDto
 */
export interface InitiativeActivityEventDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    activityType?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    actorId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeActivityEventDto
     */
    details?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeActivityEventDto
     */
    occurredAt?: Date;
}

/**
 * Check if a given object implements the InitiativeActivityEventDto interface.
 */
export function instanceOfInitiativeActivityEventDto(value: object): value is InitiativeActivityEventDto {
    return true;
}

export function InitiativeActivityEventDtoFromJSON(json: any): InitiativeActivityEventDto {
    return InitiativeActivityEventDtoFromJSONTyped(json, false);
}

export function InitiativeActivityEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeActivityEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'activityType': json['activityType'] == null ? undefined : json['activityType'],
        'actorId': json['actorId'] == null ? undefined : json['actorId'],
        'status': json['status'] == null ? undefined : json['status'],
        'details': json['details'] == null ? undefined : json['details'],
        'occurredAt': json['occurredAt'] == null ? undefined : (new Date(json['occurredAt'])),
    };
}

export function InitiativeActivityEventDtoToJSON(json: any): InitiativeActivityEventDto {
    return InitiativeActivityEventDtoToJSONTyped(json, false);
}

export function InitiativeActivityEventDtoToJSONTyped(value?: InitiativeActivityEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'activityType': value['activityType'],
        'actorId': value['actorId'],
        'status': value['status'],
        'details': value['details'],
        'occurredAt': value['occurredAt'] == null ? undefined : ((value['occurredAt']).toISOString()),
    };
}

